import { render, staticRenderFns } from "./FlowCard.vue?vue&type=template&id=489ff575&scoped=true"
import script from "./FlowCard.vue?vue&type=script&lang=js"
export * from "./FlowCard.vue?vue&type=script&lang=js"
import style0 from "./FlowCard.vue?vue&type=style&index=0&id=489ff575&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489ff575",
  null
  
)

export default component.exports